import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connectorDefinition.DOC}
  query IntegrationConnectorDefinitions($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        intgConnectorDefinitions {
          ...FragmentIntegrationConnectorDefinition
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.IntegrationConnectorDefinitionsQuery,
    readonly ents.core.integrations.Connector.Definition[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'intgConnectorDefinitions',
        graphql.transformers.OUT.list(
          fragments.connectorDefinition.TRANSFORMER,
          { onNullish: 'remove' },
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.IntegrationConnectorDefinitionsQuery,
  readonly ents.core.integrations.Connector.Definition[],
  graphql.schema.IntegrationConnectorDefinitionsQueryVariables
>({ query: DOC, transformer: TRANSFORMER })
